import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IRefreshToken } from "src/app/model/custom/IAuth";
import {
	IAuthenticatedUserChangePasswordPayload,
	IAuthenticatedUserChangeUserNamePayload,
	IAuthenticatedUserEnable2FaFinishPayload,
	IAuthenticatedUserEnable2FaStartPayload,
} from "src/app/model/custom/IAuthenticatedUser";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class AuthenticatedUserService {
	private http: HttpClient = inject(HttpClient);

	ChangePassword(data: IAuthenticatedUserChangePasswordPayload): Observable<any> {
		return this.http.post(
			`${environment.apiURL}/user-authenticated/change-password/`,
			data,
		);
	}

	Enable2FaStart(data: IAuthenticatedUserEnable2FaStartPayload): Observable<any> {
		return this.http.post(
			`${environment.apiURL}/user-authenticated/enable-2fa-start/`,
			data,
		);
	}

	Enable2FaFinish(data: IAuthenticatedUserEnable2FaFinishPayload): Observable<any> {
		return this.http.post(
			`${environment.apiURL}/user-authenticated/enable-2fa-finish/`,
			data,
		);
	}

	ChangeUserName(data: IAuthenticatedUserChangeUserNamePayload): Observable<any> {
		return this.http.post(
			`${environment.apiURL}/user-authenticated/change-username/`,
			data,
		);
	}
	RefreshToken(data: IRefreshToken) {
		return this.http.post(`${environment.apiURL}/user/refresh-token`, data);
	}
}
